import { BaseQuery2 } from '@/utils';

/**
 * @startDate
 * @endDate
 * @scanSite
 * @destinationSites
*/
export const TableQuery = params => {
  const { scanProvinceArea, scanSite, receiveSite, destinationSite } = params;
  const arr = []
  scanProvinceArea && arr.push({key: 'scanProvinceArea', value: scanProvinceArea});
  scanSite && arr.push({key: 'scanSite', value: scanSite});
  receiveSite && arr.push({key: 'receiveSite', value: receiveSite});
  destinationSite && arr.push({key: 'destinationSite', value: destinationSite});
  return [
    {
      // 获取接货网点
      simpleGranularity: 'all',
      dataSource: 'opt_stock_site_result',
      dimensions: ['receiveSite', 'scanProvinceArea', 'destinationSite', 'scanSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: arr,
    },
    // 一派留仓
    [
      {
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_result',
        dimensions: ['destinationSite', 'leaveTime', 'scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [{key: 'type', value: '一派留仓'}],
        inFilters: [
          { key: 'destinationSite', value: params.destinationSites },
        ],
      },
      {
        // 优势产品
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_result',
        dimensions: ['destinationSite','scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          {key: 'type', value: '一派留仓'},
          {key: 'superiorityProduct', value: '是'}
        ],
        inFilters: [
          {key: 'destinationSite', value: params.destinationSites},
        ],
      },
      {
        // 定时达
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_result',
        dimensions: ['destinationSite','scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          {key: 'type', value: '一派留仓'},
          {key: 'productType', value: '定时达'}
        ],
        inFilters: [
          {key: 'destinationSite', value: params.destinationSites},
        ],
      },
    ],
    // 二派留仓
    [
      {
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_result',
        dimensions: ['destinationSite', 'leaveTime', 'scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [{key: 'type', value: '二派留仓'}],
        inFilters: [
          {key: 'destinationSite', value: params.destinationSites},
        ],
      },
      {
        // 优势产品
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_result',
        dimensions: ['destinationSite','scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          {key: 'type', value: '二派留仓'},
          {key: 'superiorityProduct', value: '是'}
        ],
        inFilters: [
          {key: 'destinationSite', value: params.destinationSites},
        ],
      },
      {
        // 定时达
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_result',
        dimensions: ['destinationSite','scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          {key: 'type', value: '二派留仓'},
          {key: 'productType', value: '定时达'}
        ],
        inFilters: [
          {key: 'destinationSite', value: params.destinationSites},
        ],
      },
    ]
  ]
}